import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Select,
  Tooltip,
  Menu,
  IconButton,
  Checkbox,
  FormControl,
  Autocomplete,
  ListSubheader,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate, useParams } from "react-router-dom";
import { CiCirclePlus, CiEdit, CiFilter } from "react-icons/ci";
import SearchBar from "../../SearchBar";
import TableDownloader from "../../TableDownloader";
import { CiViewList } from "react-icons/ci";
import { Modal, Offcanvas } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { IoIosArrowBack } from "react-icons/io";
import { ExpandMore } from "@mui/icons-material";
import { newFilterEntities, postResource,} from "../../../apis/apiService";
import { format } from "date-fns";
import { toast } from "react-toastify";
import Loader, { BtnLoader } from "../../common/Loader";
import { renderOverviewCell } from "../../../utils/mapOverviewData";
import { useSelector } from "react-redux";
import {
  useFetchGetAllProjectBasedUserNameListQuery,
  useFetchMasterAllStatusQuery,
  useFetchMilestoneNamesQuery,
} from "../../../slice/logdetailSlice";
import apiSlice from "../../../slice/logdetailSlice";
import { useDispatch } from "react-redux";
import { CustomNoRowsOverlay } from "../../common/OverlayGrid";
import CommonDeleteDialog from "../../common/CommonDelete";
import dayjs from "dayjs";
import { validateEndDate, validateStartDate } from "../../common/PreventValidate";
import { usePersistentFilter } from "../../../assets/hooks/usePersistentFilter";
import { FilterSummaryBox } from "../../common/FilterSummaryBox";
import { useTheme } from "../../../ThemeContext";
import { openInNewTab } from "../../../utils/openInNewTab";


const MilestoneFilterComponent = ({
  onApply,
  onClear,
  onCancel,
  view_type_id,
}) => {
  const {
    handleSubmit,
    control,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      projectName: "",
      Owner: "",
      Status: "",
      startDate: null,
      endDate: null,
    },
  });
  const [loading, setLoading] = useState(false);
  const project_id = localStorage.getItem("project_id");
  const { data: milestoneNames, } = useFetchMilestoneNamesQuery(project_id);
  ////console.log()("milestoneNames_list", milestoneNames);

  const usersInProjects = useSelector((state) => state.selectOptions?.userNamesByProjects,);
  ////console.log()("userNamesByProjects", usersInProjects);

  const activestatus = useSelector((state) => state.selectOptions.StatusOptions,);
  const activityStatus = activestatus.find((status) => status.status_type === "MILESTONE",);
  const statusList = activityStatus?.status_details.map((status) => ({
    id: status.status_id,
    status_name: status.status_name,
    status_colour: status.status_colour,
  }));

  const onSubmit = async (data) => {
    ////console.log()(data);
    setLoading(true);
    const requestedData = {
      name: data.projectName,
      view_type_id: view_type_id,
      owner_id: data.Owner, // the API filters milestones by owner_id (added_by is ignored)
      current_status_id: data.Status,
      start_date: data.startDate
        ? format(new Date(data.startDate), "yyyy-MM-dd")
        : null,
      end_date: data.endDate
        ? format(new Date(data.endDate), "yyyy-MM-dd")
        : null,
    };
    ////console.log()("requested data :", requestedData);
    // const
    try {
      const response = await newFilterEntities("milestones/show",project_id,requestedData,);
      if (response.data) {
        toast.success("Milestone filter applied successfully!");
        ////console.log()("filtered projects : ", response.data);
        onApply(response.data);
        sessionStorage.setItem("isMilestoneFilterApplied", true);
        sessionStorage.setItem(
          "milestone_filter_data",
          JSON.stringify(requestedData),
        );
      }
    } 
    catch (error) {
      // console.error("Failed to filter projects:", error);
      const errorMsg = error.message;
      toast.error(errorMsg);
    } 
    finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    reset();
  };

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray  align-items-center">
            <IoIosArrowBack className=" text-rgba-gray" />
            Filter
          </div>
        </button>

        <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red clear-filter-btn"
          >
            Clear Filter
          </button>
        </div>
      </div>

      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="">
              <div className="row mb-3">
                {/* <div className="col-md-12">
                  <div className="row">
                    <div className="row"> */}
                <div className="col-12">
                  <label htmlFor="projecttitle" className="form-label">
                    Filter by milestones
                  </label>
                  <Controller
                    name="projectName"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        multiple
                        id="projectName"
                        options={milestoneNames ? milestoneNames : []}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.name}
                        value={
                          (value || []).map((name) =>
                                  milestoneNames.find(
                                    (user) => user.name === name,
                                  ),
                          ) || []
                        }
                        onChange={(event, newValue) => {
                          const selectedTitles = newValue.map(
                                  (user) => user.name,
                          );
                          onChange(selectedTitles);
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{option.name}</strong>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Filter by milestones"
                            fullWidth
                          />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                            paddingLeft: "0",
                          },
                        }}
                      />
                    )}
                  />
                      {/* </div>
                    </div>
                  </div> */}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="Owner" className="form-label">
                    Owner
                  </label>

                  <Controller
                    control={control}
                    name="Owner"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          IconComponent={ExpandMore}
                          value={field.value || ""}
                          displayEmpty
                          // onChange={(e) => {
                          //   field.onChange(e.target.value); // Update form state
                          //   // setValue("status", e.target.value); // Optionally set value
                          // }}
                          renderValue={(selected) =>
                            selected ? (
                              usersInProjects.find(
                                (namelist) => namelist.user_id === selected,
                              )?.name
                            ) : (
                              <span className=" lightText">Select owner</span>
                            )
                          }
                        >
                          {usersInProjects.map((ownerName, index) => (
                            <MenuItem key={index} value={ownerName.user_id}>
                              {ownerName.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                <div className="col-md-6">
                  <label htmlFor="Status" className="form-label">
                    Status
                  </label>
                  <FormControl fullWidth>
                    <Controller
                      name="Status"
                      control={control}
                      render={({ field }) => (
                        <Select
                          {...field}
                          value={field.value || ""}
                          onChange={(e) => {
                            field.onChange(e.target.value); // Update form state
                            // setValue("status", e.target.value); // Optionally set value
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            const selectedValue = statusList?.find(
                              (statusName) => statusName.id === selected,
                            );
                            return selectedValue ? (
                              <span
                                style={{ color: selectedValue.status_colour }}
                              >
                                {selectedValue.status_name}
                              </span>
                            ) : (
                              <span className=" lightText">Select status</span>
                            );
                          }}
                          IconComponent={ExpandMoreIcon}
                        >
                          {statusList.map((status, index) => (
                            <MenuItem
                              key={index}
                              sx={{ color: status.status_colour || "black" }}
                              value={status.id}
                            >
                              {status.status_name}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="startDate" className="form-label">
                    Start Date
                  </label>
                  <div className="d-flex  flex-column w-100">
                    <Controller
                      name="startDate"
                      control={control}
                      rules={{
                        validate: (val) => {
                          if (!val) return true;
                          const d = dayjs(val);
                          if (!d.isValid()) return "Invalid date format";
                          if (d.year() < 1990) return "Invalid date format";
                          return true;
                        }
                      }}
                      render={({ field }) => (
                        <>
                          <DatePicker
                            {...field}
                            format="DD/MM/YYYY"
                            className="datepicker_input w-100"
                            onChange={(date) => {
                              const endDate = getValues("endDate");
                              if (date && endDate && !validateStartDate(date, endDate)) {
                                const current = getValues("startDate");
                                setValue("startDate", null);
                                setTimeout(() => setValue("startDate", current), 0);
                                return;
                              }
                              field.onChange(date);
                            }}
                            renderInput={(params) => (
                              <input
                                className="form-control datepicker_input"
                                {...params}
                              />
                            )}
                          />
                          {errors.startDate && (
                            <span className="text-danger">
                              {errors.startDate.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <label htmlFor="endDate" className="form-label">
                    End Date
                  </label>
                  <div className="d-flex  flex-column w-100">
                    <Controller
                      name="endDate"
                      control={control}
                      rules={{
                        validate: (val) => {
                          if (!val) return true;
                          const d = dayjs(val);
                          if (!d.isValid()) return "Invalid date format";
                          if (d.year() < 1990) return "Invalid date format";
                          return true;
                        }
                      }}
                      render={({ field }) => (
                        <>
                          <DatePicker
                            {...field}
                            format="DD/MM/YYYY"
                            className="w-100"
                            onChange={(date) => {
                              const startDate = getValues("startDate");
                              if (date && startDate && !validateEndDate(startDate, date)) {
                                const current = getValues("endDate");
                                setValue("endDate", null);
                                setTimeout(() => setValue("endDate", current), 0);
                                return;
                              }
                              field.onChange(date);
                            }}
                            renderInput={(params) => (
                              <input
                                className="form-control datepic_ip"
                                {...params}
                              />
                            )}
                          />
                          {errors.endDate && (
                            <span className="text-danger">
                              {errors.endDate.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex position-absolute bottom-0 w-100 bg-white py-2 justify-content-start mt-3">
                <button
                  type="submit"
                  className="me-3 add_btn"
                  disabled={loading}
                >
                  {loading ? "Applying..." : "Apply"}
                </button>
                <button type="button" className="cancel_btn" onClick={onCancel}>
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

const AddMilestoneComponent = ({
  fetchMilestone,
  onApply,
  onClear,
  onCancel,
}) => {
  const [cloneMilestoneId, setCloneMilestoneId] = useState(0);
  const {
    handleSubmit,
    control,
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      MilestoneName: "",
      owner: "",
      StartDate: null,
      EndDate: null,
      project: null,
      Milestone: null,
    },
  });
  const [loading, setLoading] = useState(false);
  const project_id = localStorage.getItem("project_id");
  const projectNames = useSelector(
    (state) => state.selectOptions.ProjectNameOptions,
  );
  ////console.log()("task_filter_project name: ", projectNames);
  const { data: usersInProjects } =
    useFetchGetAllProjectBasedUserNameListQuery(project_id);
  // const usersInProjects = useSelector(
  //   (state) => state.selectOptions?.userNamesByProjects
  // );
  ////console.log()("userNamesByProjects", usersInProjects);
  // const {
  //   data: projectData,
  //   refetch,
  //   isLoading,
  // } = 
  useFetchMilestoneNamesQuery(project_id);
  const handleAddMore = (e) => {
    e.preventDefault();
    handleSubmit((data) => addMoreMilestones(data))();
  };
  const addMoreMilestones = async (data) => {
    setLoading(true);
    const requestData = {
      milestone_name: data.MilestoneName,
      owner_id: data.owner,
      start_date: data.StartDate
        ? format(new Date(data.StartDate), "yyyy-MM-dd")
        : null,
      end_date: data.EndDate
        ? format(new Date(data.EndDate), "yyyy-MM-dd")
        : null,
      project_id: data.project,
      clone_milestone_id: data.Milestone,
    };
    try {
      // Call the API to create the entity
      const response = await postResource("milestones", "add", project_id, requestData );
      toast.success(response.message);
      onCancel();
      fetchMilestone();
      //  fetchIssues();
    } 
    catch (error) {
      toast.error(error.message || error.response.data.message);
    } 
    finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const requestData = {
      milestone_name: data.MilestoneName,
      owner_id: data.owner,
      start_date: data.StartDate
        ? format(new Date(data.StartDate), "yyyy-MM-dd")
        : null,
      end_date: data.EndDate
        ? format(new Date(data.EndDate), "yyyy-MM-dd")
        : null,
      project_id: data.project,
    };
    try {
      // Call the API to create the entity
      const response = await postResource("milestones","add", project_id, requestData,);
      toast.success(response.message);
      onCancel();
      fetchMilestone();
      //  fetchIssues();
    } 
    catch (error) {
      toast.error(error.message || error.response.data.message);
    } 
    finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (event) => {
    setCloneMilestoneId(event.target.checked ? 1 : 0); // Update state based on checkbox
  };

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex  text-rgba-gray align-items-center">
            <IoIosArrowBack className=" text-rgba-gray" />
            Add New Milestone
          </div>
        </button>
      </div>

      <div className="bg-white px-4 py-3 ">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className="row ">
                <div className="col-12">
                  <div>
                    <label htmlFor=" MilestoneName " className="form-label">
                      Milestone Name
                      <span className=" errorMsg"> *</span>
                    </label>
                    <TextField
                      type="text"
                      id="MilestoneName"
                      placeholder="Enter milestone name"
                      className="form-control"
                      {...register("MilestoneName", {
                        required: "Milestone name is required",
                      })}
                    />
                    {errors.MilestoneName && (
                      <span className="text-danger">
                        {errors.MilestoneName.message}
                      </span>
                    )}
                  </div>

                  {/* <Checkbox
                    checked={cloneMilestoneId === 1}
                    onChange={handleCheckboxChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <label className="text-rgbr-blue">
                    Clone from Existing Milestone
                  </label> */}
                </div>
              </div>
              {/* {cloneMilestoneId === 1 && (
                <div className="row ">
                  <div className="col-md-12">
                    <label htmlFor=" Project " className="form-label">
                      Project
                    </label>
                    <Autocomplete
                      disablePortal
                      options={projectNames}
                      id="project"
                      getOptionLabel={(option) => option.title}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select project" />
                      )}
                    />
                  </div>
                  <div className="col-md-12 pt-3">
                    <label htmlFor=" Milestone " className="form-label">
                      Milestone
                    </label>
                    <Autocomplete
                      disablePortal
                      options={projectData}
                      id="Milestone"
                      placeholder="Milestones"
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Select milestone" />
                      )}
                    />
                  </div>
                </div>
              )} */}

              <div className="row mb-3 pt-3">
                <div className="col-md-12">
                  <label htmlFor="owner" className="form-label">
                    Owner
                  </label>
                  <span className="text-rgbr-red"> *</span>
                  <FormControl fullWidth>
                    <Select
                      labelId="owner-label"
                      id="owner"
                      {...control.register("owner")}
                      IconComponent={ExpandMore}
                      displayEmpty
                      renderValue={(selected) =>
                        selected ? (
                          usersInProjects?.find(
                            (owner) => owner.user_id === selected,
                          )?.name
                        ) : (
                          <span className="lightText">Select owner</span>
                        )
                      }
                    >
                      {usersInProjects?.map((user, index) => (
                        <MenuItem value={user.user_id} key={index}>
                          {user.name}
                        </MenuItem>
                      ))}
                      {/* Add other options as needed */}
                    </Select>
                  </FormControl>
                </div>
              </div>

              <div className="paddingBtn row">
                <div className="col-md-6 pt-3">
                  <label htmlFor="Start Date" className="form-label">
                    Start Date
                  </label>
                  <div className="d-flex  flex-column w-100">
                    <Controller
                      name="StartDate"
                      control={control}
                      rules={{
                        validate: (val) => {
                          if (!val) return true;
                          const d = dayjs(val);
                          if (!d.isValid()) return "Invalid date format";
                          if (d.year() < 1990) return "Invalid date format";
                          return true;
                        }
                      }}
                      render={({ field }) => (
                        <>
                          <DatePicker
                            format="DD/MM/YYYY"
                            {...field}
                            onChange={(date) => {
                              const endDate = getValues("EndDate");
                              if (date && endDate && !validateStartDate(date, endDate)) {
                                const current = getValues("StartDate");
                                setValue("StartDate", null);
                                setTimeout(() => setValue("StartDate", current), 0);
                                return;
                              }
                              field.onChange(date);
                            }}
                            renderInput={(params) => (
                              <input className="form-control" {...params} />
                            )}
                          />
                          {errors.StartDate && (
                            <span className="text-danger">
                              {errors.StartDate.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>

                <div className="col-md-6 pt-3">
                  <label htmlFor="EndDate" className="form-label">
                    End Date
                  </label>
                  <div className="d-flex  flex-column w-100">
                    <Controller
                      name="EndDate"
                      control={control}
                      rules={{
                        validate: (val) => {
                          if (!val) return true;
                          const d = dayjs(val);
                          if (!d.isValid()) return "Invalid date format";
                          if (d.year() < 1990) return "Invalid date format";
                          return true;
                        }
                      }}
                      render={({ field }) => (
                        <>
                          <DatePicker
                            {...field}
                            format="DD/MM/YYYY"
                            onChange={(date) => {
                              const startDate = getValues("StartDate");
                              if (date && startDate && !validateEndDate(startDate, date)) {
                                const current = getValues("EndDate");
                                setValue("EndDate", null);
                                setTimeout(() => setValue("EndDate", current), 0);
                                return;
                              }
                              field.onChange(date);
                            }}
                            renderInput={(params) => (
                              <input className="form-control" {...params} />
                            )}
                          />
                          {errors.EndDate && (
                            <span className="text-danger">
                              {errors.EndDate.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>
              </div>

              <div
                className="bg-white position-absolute bottom-0
                w-100   p-2"
              >
                <div className="d-flex   justify-content-left mt-3">
                  <button
                    type="submit"
                    className="me-3 add_btn"
                    disabled={loading}
                  >
                    {loading ? "Adding..." : "Add"}
                  </button>
                  <button
                    type="button"
                    className="addmore_btn me-3"
                    onClick={handleAddMore}
                  >
                    Add more
                  </button>
                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

const MilestoneTab = () => {
  const { isDarkMode } = useTheme();
  const dispatch = useDispatch();
  const [expandedRows, setExpandedRows] = useState({});
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [loading, setLoading] = useState(false);
  const [Milestone, setMilestone] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [isMilestoneEdit, setIsMilestoneEdit] = useState(false);
  const [checkedTasks, setCheckedTasks] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });
  const [showEditModal, setShowEditModal] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [clearFilter, setClearFilter] = useState(false);
  const navigate = useNavigate();
  const ProjectID = localStorage.getItem("project_id");
  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  ////console.log()("login_user_detail in redux state: ", loginUser);
  const { id: login_user_id, role: login_user_role } = loginUser;
  const [filter, setFilter] = usePersistentFilter(
    "projectMilestoneFilter",
    login_user_role === "CLIENT" || login_user_role === "ADMIN" ? 1 : 6,
  );
  const { data, refetch } = useFetchMasterAllStatusQuery();
  const [fields, setFields] = useState([]);

  useEffect(() => {
    if (data) {
      const milestoneStatus = data.find(
        (list) => list?.status_type === "MILESTONE",
      );
      if (milestoneStatus) {
        const newFields = milestoneStatus?.status_details.map((status) => ({
          id: status.status_id,
          status_name: status.status_name,
          status_colour: status.status_colour,
        }));

        setFields(newFields);
        if (selectedSubtask && showEditModal) {
          editReset({
            MilestoneName: selectedSubtask.name || "",
            owner: selectedSubtask.owner?.user_id
              ? Number(selectedSubtask.owner?.user_id)
              : "",
            StartDate: selectedSubtask.start_date
              ? dayjs(selectedSubtask.start_date)
              : null,
            status_id: selectedSubtask?.status
              ? Number(selectedSubtask?.status?.status_id)
              : "",
            EndDate: selectedSubtask.end_date
              ? dayjs(selectedSubtask.end_date)
              : null,
          });
        }
      }
    }
  }, [data]);

  const { reset } = useForm();
  const { id: project_id } = useParams();
  ////console.log()("project_id_in_milestone :", project_id);
  const { data: usersInProjects, refetch: project_based_users_refetch } =
    useFetchGetAllProjectBasedUserNameListQuery(project_id);
  const handleCheckboxChange = (event, row) => {
    event.stopPropagation(); // Prevents row click navigation

    setCheckedTasks((prev) => ({
      ...prev,
      [row.milestone_id]: event.target.checked, // Ensure only one checkbox is toggled
    }));
  };
  const {
    handleSubmit: handleEditSubmit,
    control: editControl,
    reset: editReset,
    register: editRegister,
    formState: { errors: editErrors },
  } = useForm({
    defaultValues: {
      MilestoneName: "",
      owner: "",
      StartDate: null,
      EndDate: null,
    },
  });
  const handleActionClick = (event, row) => {
    event.stopPropagation(); // Prevent row click navigation
    setAnchorEl(event.currentTarget);
    ////console.log()("row_milestone_id :", row.milestone_id);

    setSelectedTask(row.milestone_id); // Ensure selectedTask gets the correct ID
  };
  // Close menu
  const handleClose = () => {
    setAnchorEl(null);
    setSelectedSubtask(null);
  };

  useEffect(() => {
    if (selectedSubtask && showEditModal && fields.length > 0) {
      editReset({
        MilestoneName: selectedSubtask.name || "",
        owner: selectedSubtask?.owner?.user_id
          ? Number(selectedSubtask.owner?.user_id)
          : "",
        StartDate: selectedSubtask.start_date
          ? dayjs(selectedSubtask.start_date)
          : null,
        EndDate: selectedSubtask.end_date
          ? dayjs(selectedSubtask.end_date)
          : null,
        status_id: Number(selectedSubtask?.status?.status_id),
      });
    }
  }, [selectedSubtask, showEditModal, fields]);

  // Re-apply owner once usersInProjects loads (async timing fix)
  useEffect(() => {
    if (
      selectedSubtask &&
      showEditModal &&
      Array.isArray(usersInProjects) &&
      usersInProjects.length > 0
    ) {
      const ownerExists = usersInProjects.some(
        (u) => u.user_id === Number(selectedSubtask.owner?.user_id),
      );
      if (ownerExists) {
        editReset((prev) => ({
          ...prev,
          owner: Number(selectedSubtask.owner?.user_id),
        }));
      }
    }
  }, [usersInProjects]);
  const onEditSubmit = async (data) => {
    setEditLoading(true);
    const requestData = {
      milestone_name: data.MilestoneName,
      owner_id: data.owner,
      current_status_id: data.status_id,
      start_date: data.StartDate
        ? format(new Date(data.StartDate), "yyyy-MM-dd")
        : null,
      end_date: data.EndDate
        ? format(new Date(data.EndDate), "yyyy-MM-dd")
        : null,
      project_id: ProjectID,
    };
    try {
      const response = await postResource(
        "milestones",
        "update",
        selectedSubtask.milestone_id, // ✅ milestone_id as header
        requestData,
      );
      toast.success(response.message);
      setShowEditModal(false);
      dispatch(apiSlice.util.invalidateTags(["Timesheet", "Milestone"]));
      sessionStorage.removeItem("timesheet_filter");
      fetchMilestone();
    } 
    catch (error) {
      toast.error(error.message || error.response?.data?.message);
      // ✅ stay in modal on error
    } 
    finally {
      setEditLoading(false);
    }
  };
  useEffect(() => {
    refetch();
    project_based_users_refetch();
  }, []);

  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        return (
          <Box display="flex" alignItems="center">
            {/* More options button */}
            <IconButton
              onClick={(event) => {
                handleMenuOpen(event, params.row.milestone_id); // Open menu for the row
                setSelectedSubtask(params.row);
              }}
            >
              <MoreVertIcon />
            </IconButton>
          </Box>
        );
      },
    },
    {
      field: "milestone_id",
      headerName: "ID",
      width: 100,
      renderCell: (params) => <Box>{params.value}</Box>,
    },
    {
      field: "name",
      headerName: "Milestones Name",
      width: 200,
    },
    {
      field: "completed_percentage",
      headerName: "Completed %",
      width: 120,
      // valueGetter: (params) => `${params.row.completed_percentage}%`,
    },
    {
      field: "owner_name",
      headerName: "Owner",
      width: 150,
      renderCell: (params) => params.row.owner?.name || "N/A",
    },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 180,
      renderCell: (params) => {
        const status = params.value;
        let color = params.row.status_colour;

        return (
          <Box
            sx={{
              color: color,
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            {status}
          </Box>
        );
      },
    },
    {
      field: "start_date",
      headerName: "Start Date",
      width: 150,
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("YYYY-MM-DD") : "N/A",
    },
    {
      field: "end_date",
      headerName: "End Date",
      width: 150,
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("YYYY-MM-DD") : "N/A",
    },
    {
      field: "task_overview",
      headerName: "Task",
      width: 150,
      renderCell: (params) => {
        return (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100%"
            width="100%"
          >
            {renderOverviewCell(params, "task_overview")}
          </Box>
        );
      },
    },
    {
      field: "issue_overview",
      headerName: "Issues",
      width: 150,
      renderCell: (params) => {
        return (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100%"
            width="100%"
          >
            {renderOverviewCell(params, "issue_overview")}
          </Box>
        );
      },
    },
    {
      field: "project_name",
      headerName: "Project Name",
      width: 180,
      renderCell: (params) => params.row.project?.title || "N/A",
    },
    {
      field: "added_by_name",
      headerName: "Added By",
      width: 150,
      renderCell: (params) => params.row.added_by?.name || "N/A",
    },
    {
      field: "added_at",
      headerName: "Added At",
      width: 180,
      renderCell: (params) => {
        if (!params.value) return "N/A";
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY hh:mm A") : params.value}
          </Box>
        );
      },
    },
    {
      field: "updated_by",
      headerName: "Updated By",
      width: 150,
      renderCell: (params) => {
        const val = params.row.updated_by?.name || params.row.updated_by;
        return (
          <Box>
            {val || "-"}
          </Box>
        );
      },
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 180,
      renderCell: (params) => {
        if (!params.value) return "-";
        const d = dayjs(params.value);
        return (
          <Box>
            {d.isValid() ? d.format("DD-MM-YYYY hh:mm A") : params.value}
          </Box>
        );
      },
    },
  ];

  const fetchSearchedMilestone = async (searchQuery) => {
    // setLoading(true);
    try {
      const response = await newFilterEntities("milestones/show", ProjectID, {
        // search: searchQuery,
        search: searchQuery.trim(),
      });
      if (response.status) {
        setMilestone(response.data);
      } 
      else {
        setMilestone([]);
      }
    } 
    catch (error) {
      console.error("Failed to fetch Milestone:", error);
      setMilestone([]);
      // Handle the error appropriately in the caller
    // } finally {
    //   setLoading(false);
    }
  };

  const fetchMilestone = async () => {
    setLoading(true);
    const requestedData = {
      view_type_id: filter,
    };
    try {
      const response = await newFilterEntities( "milestones/show", ProjectID, requestedData );

      if (response) {
        const data = response.data;
        setMilestone(data);
        setClearFilter(false);
      } 
      else {
        console.error("No Milestone found in the response.");
      }
    } 
    catch (error) {
      console.error("Error fetching issues:", error);
    } 
    finally {
      setLoading(false); // Stop loader
    }
  };

  useEffect(() => {
    fetchMilestone();
  }, [filter]);

  const handleShowFilter = () => setShowFilter(true); // Open filter
  const handleShowProject = () => setShowProject(true); // Open filter
  const toggleExpandRow = (taskId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [taskId]: !prev[taskId],
    }));
  };

  const handleMenuOpen = (event, rowId) => {
    event.stopPropagation(); // Prevent row click event
    setMenuAnchorEl(event.currentTarget); // Open the menu
    setSelectedTask(rowId); // Store the selected task ID
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedTask(null);
  };

  const handleClone = () => {
    ////console.log()(`Clone task: ${selectedTask}`);
    handleMenuClose();
  };

  const handleView = () => {
    ////console.log()(`View_task: ${selectedTask}`);
    navigate(
      `/projects/projectDetail/${project_id}/milestone/MilestoneDetail/${selectedTask}`,
    );
    handleMenuClose();
  };

  const handleViewDitailstab = () => {
    ////console.log()(`View_task on new tab: ${selectedTask}`);
    const path = `/projects/projectDetail/${project_id}/milestone/MilestoneDetail/${selectedTask}`;
    openInNewTab(path);
    handleMenuClose();
  };

  const handleCopylink = () => {
    ////console.log()(`Copy task: ${selectedTask}`);
    handleMenuClose();
  };

  const filterOptions = {
    predefined: [
      { label: "All Milestone", value: 1 },
      { label: "All Open", value: 2 },
      { label: "All Closed", value: 3 },
      { label: "All Overdue & Open", value: 4 },
      { label: "Unassigned", value: 5 },
    ],
    // ...(login_user_role === "CLIENT" && {
    myViews: [
      { label: "My Open", value: 6 },
      { label: "My Closed", value: 7 },
      { label: "My Overdue & Open", value: 8 },
      { label: "Milestone I Follow", value: 9 },
      { label: "Milestone Created By Me", value: 10 },
    ],
    // }),
  };

  const handleFilterChange = (event) => {
    const value = event.target.value;
    setFilter(value);
  };

  const handleApplyFilter = (filteredData) => {
    setMilestone(
      // filteredData.map((project) => ({
      //   ...project,
      //   id: project.milestone_id, // Ensure DataGrid has a unique ID
      // }))
      filteredData.map((project) => ({
        ...project,
        id: project.task_id,
      })),
    );

    setShowFilter(false);
    setClearFilter(true);
  };

  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value) {
      await fetchSearchedMilestone(value);
    } 
    else {
      await fetchMilestone();
      // setIssues([]); // Clear projects if search term is empty
    }
  };

  // Handle row click
  const handleRowClick = (params) => {
    const { milestone_id } = params.row;
    navigate(`/projects/projectDetail/${project_id}/milestone/MilestoneDetail/${milestone_id}`);
  };
  ////console.log()("checking_milestone :", selectedTask);
  ////console.log()("checking_milestone :", Milestone);
  const handleClearFilter = () => {
    fetchMilestone();
    sessionStorage.setItem("isMilestoneFilterApplied", false);
    sessionStorage.removeItem("milestone_filter_data");
  };
  useEffect(() => {
    sessionStorage.setItem("isMilestoneFilterApplied", false);
    sessionStorage.removeItem("milestone_filter_data");
  }, []);

  return (
    <>
      {/* Add  Project */}
      <Offcanvas
        show={showProject}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          <AddMilestoneComponent
            // onApply={handleApplyFilter}
            // onClear={handleClearFilter}

            // onCancel={() => setShowFilter(false)}
            fetchMilestone={fetchMilestone}
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      {/* Add filter */}
      <Offcanvas
        show={showFilter}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          <MilestoneFilterComponent
            // onApply={handleApplyFilter}
            // onClear={handleClearFilter}
            // onCancel={() => setShowFilter(false)}
            onApply={handleApplyFilter}
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowFilter(false)}
            view_type_id={filter}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      <div style={{ padding: "9px 16px" }} className="bg-white">
        <Box
          className="row align-items-center"
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "9px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
            mx: 0,
          }}
        >
          <div className="col-12 col-lg-2 col-md-4" style={{ paddingLeft: 0 }}>
            <FormControl sx={{ width: "auto" }} size="small">
              <Select
                value={filter}
                onChange={handleFilterChange}
                displayEmpty
                size="small"
                autoWidth
              >
                <ListSubheader className="ps-3 text-rgba-gray">
                  Predefined Views
                </ListSubheader>
                {filterOptions.predefined.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}

                <ListSubheader className="ps-3 text-rgba-gray">
                  My Views
                </ListSubheader>
                {filterOptions.myViews.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div
            className="col-12 col-lg-10 col-md-8 d-flex flex-wrap justify-content-md-end gap-2 align-items-center"
            style={{ paddingRight: 0 }}
          >
            <SearchBar
              placeholder="Search milestone"
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
            />
            {clearFilter && (
              <button
                type="button"
                className=" addmore_btn"
                onClick={handleClearFilter}
              >
                Clear filter
              </button>
            )}

            {login_user_role !== "CLIENT" && (
              <Button
                className="AddButton rounded me-2 ms-2"
                onClick={handleShowProject}
                startIcon={<CiCirclePlus className="ms-1" />}
              >
                Add Milestone
              </Button>
            )}

            <Tooltip title="Filter">
              <IconButton
                onClick={handleShowFilter}
                sx={{
                  backgroundColor: isDarkMode
                    ? "rgba(67, 105, 255, 0.08)"
                    : "#F1F5FF",
                  borderRadius: "50%",
                  width: "39px",
                  height: "39px",
                  marginLeft:"5px",
                  marginRight:"7px",
                  color: "rgba(18, 183, 159, 1)",
                  "&:hover": {
                    backgroundColor: "var(--icon-hover-bg)",
                  },
                }}
              >
                <CiFilter className="pro-icon-s" />
              </IconButton>
            </Tooltip>

            <TableDownloader
              columns={columns}
              rows={Milestone}
              fileName="Milestones_Export.csv"
              confirmBeforeDownload={true}
            />
          </div>
        {/* </div> */}
      </Box>
      
        {loading ? (
          <Loader /> // Display loader while loading
        ) : (
          <div className="row">
            <div className="col-12 ">
              <FilterSummaryBox
                onApply={handleApplyFilter}
                status_type="MILESTONE"
                task_filter_id={project_id}
                // filter_path="/project/filter"
                filter_path="milestones/show"
                has_view_type={true}
              />
            </div>
            <Box
              style={{
                height: Milestone.length === 0 ? 300 : "100%",
                width: "100%",
              }}
            >
              <DataGrid
                rows={Milestone}
                columns={columns}
                onRowClick={handleRowClick}
                getRowId={(row) => row.milestone_id}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={[25, 50, 75, 100]}
                slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                disableSelectionOnClick
              />

              {/* Menu for Action Button Options */}
              <Menu
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                onClose={handleMenuClose}
              >
                <MenuItem onClick={handleView}>
                  <CiViewList className="me-2" color="blue" />
                  View Details
                </MenuItem>
                <MenuItem onClick={handleViewDitailstab}>
                  <CiViewList className="me-2" color="blue" />
                  View Details in New Tab
                </MenuItem>

                {selectedTask &&
                  (["ADMIN", "MANAGER"].includes(login_user_role) ||
                    Milestone.find(
                      (milestone) => milestone.milestone_id === selectedTask,
                    )?.added_by === login_user_id) && (
                    <>
                      <CommonDeleteDialog
                        name="Milestone"
                        statusName={
                          Milestone.find(
                            (list) => list.milestone_id === selectedTask,
                          )?.name
                        }
                        url="milestones/delete"
                        id={selectedTask}
                        refetchList={fetchMilestone}
                        handleListClose={handleMenuClose}
                      />
                      <MenuItem
                        onClick={() => {
                          setShowEditModal(true);
                          handleMenuClose();
                        }}
                      >
                        <CiEdit className="me-2" color="blue" />
                        Edit Milestone
                      </MenuItem>
                    </>
                  )}
              </Menu>
            </Box>
          </div>
        )}
      </div>

      {/* Edit Milestone Modal */}
      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Milestone</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <form
              id="edit-milestone-form"
              onSubmit={handleEditSubmit(onEditSubmit)}
            >
              {/* Milestone Name */}
              <div className="mb-3">
                <label htmlFor="MilestoneName" className="form-label">
                  Milestone Name <span className="errorMsg">*</span>
                </label>
                <TextField
                  type="text"
                  placeholder="Enter milestone name"
                  className="form-control"
                  {...editRegister("MilestoneName", {
                    required: "Milestone name is required",
                  })}
                />
                {editErrors.MilestoneName && (
                  <span className="text-danger">
                    {editErrors.MilestoneName.message}
                  </span>
                )}
              </div>

              {/* Owner */}
              <div className="mb-3">
                <label htmlFor="owner" className="form-label">
                  Owner <span className="text-rgbr-red">*</span>
                </label>
                <FormControl fullWidth>
                  <Controller
                    name="owner"
                    control={editControl}
                    render={({ field }) => (
                      <Select
                        {...field}
                        value={field.value || ""}
                        IconComponent={ExpandMore}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected)
                            return (
                              <span className="lightText">Select owner</span>
                            );
                          const found = usersInProjects?.find(
                            (owner) =>
                              Number(owner.user_id) === Number(selected),
                          );
                          return found ? (
                            found.name
                          ) : (
                            <span className="lightText">Select owner</span>
                          );
                        }}
                      >
                        {usersInProjects?.map((user, index) => (
                          <MenuItem value={Number(user.user_id)} key={index}>
                            {user.name}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                </FormControl>
              </div>
              
              <div className="row">
                {/* status */}
                <div className="mb-3 col-12">
                  <label htmlFor="owner" className="form-label">
                    Status <span className="text-rgbr-red">*</span>
                  </label>
                  <FormControl fullWidth>
                    <Controller
                      name="status_id"
                      control={editControl}
                      render={({ field }) => {
                        return (
                          <Select
                            {...field}
                            value={field.value || ""}
                            IconComponent={ExpandMore}
                            displayEmpty
                            renderValue={(selected) => {
                              if (!selected)
                                return (
                                  <span className="lightText">
                                    Select status
                                  </span>
                                );

                              const selectedStatus = fields?.find(
                                (s) => Number(s.id) === Number(selected),
                              );

                              return selectedStatus ? (
                                <span
                                  style={{
                                    color: selectedStatus.status_colour,
                                    fontWeight: 500,
                                  }}
                                >
                                  {selectedStatus.status_name}
                                </span>
                              ) : (
                                <span className="lightText">Select status</span>
                              );
                            }}
                          >
                            {fields?.map((status, index) => (
                              <MenuItem
                                sx={{
                                  color: status.status_colour,
                                  fontWeight: 500,
                                }}
                                value={Number(status.id)}
                                key={index}
                              >
                                {status.status_name}
                              </MenuItem>
                            ))}
                          </Select>
                        );
                      }}
                    />
                  </FormControl>
                </div>
              </div>

              {/* Start Date */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Start Date</label>
                  <Controller
                    name="StartDate"
                    control={editControl}
                    render={({ field }) => (
                      <DatePicker
                        format="DD/MM/YYYY"
                        {...field}
                        onChange={(date) => field.onChange(date)}
                        renderInput={(params) => (
                          <input className="form-control" {...params} />
                        )}
                      />
                    )}
                  />
                </div>

                {/* End Date */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">End Date</label>
                  <Controller
                    name="EndDate"
                    control={editControl}
                    render={({ field }) => (
                      <DatePicker
                        format="DD/MM/YYYY"
                        {...field}
                        onChange={(date) => field.onChange(date)}
                        renderInput={(params) => (
                          <input className="form-control" {...params} />
                        )}
                      />
                    )}
                  />
                </div>
              </div>
            </form>
          </LocalizationProvider>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="cancel_btn"
            onClick={() => setShowEditModal(false)}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="edit-milestone-form"
            className="add_btn"
            disabled={editLoading}
          >
            {editLoading ? <BtnLoader /> : "Update"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MilestoneTab;
